module.exports = "<p *ngIf=\"message\" class=\"h-100 text-danger font-weight-bold\">{{message}}</p>\r\n"